import dotProps from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';

const member_details = (state = states.member_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_AGENT_STATE: {
      return dotProps.set(state, action.path, action.payload);
    }

    case actionTypes.AGENTS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          agents_loading: true,
          agents_loaded: false,
        }
      };
    }

    case actionTypes.AGENTS_LOADED: {
      return {
        ...state,
        agents: action.payload.agentList ? action.payload.agentList : state.agents,
        active_agent: action.payload.agentList && action.payload.agentList.length > 0 ? action.payload.agentList[0] : {},
        loaders: {
          ...state.loaders,
          agents_loading: false,
          agents_loaded: true,
        }
      };
    }

    case actionTypes.AGENTS_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          agents_loading: false,
          agents_loaded: false,
        }
      };
    }

    case actionTypes.NEW_AGENTS_ADDING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          new_agent_adding: true,
        }
      };
    }

    case actionTypes.NEW_AGENTS_ADDED: {
      return {
        ...state,
        agents: action.payload.users ? [...action.payload.users, ...state.agents] : [...state.agents],
        loaders: {
          ...state.loaders,
          new_agent_adding: false,
        }
      };
    }

    case actionTypes.NEW_AGENTS_ADDITION_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          new_agent_adding: false,
        }
      };
    }

    case actionTypes.AGENT_PROFILE_DETAILS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          agent_profile_loading: true,
          agent_profile_loaded: false,
        }
      };
    }

    case actionTypes.AGENT_PROFILE_DETAILS_LOADED: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          agent_profile_loading: false,
          agent_profile_loaded: true,
        }
      };
    }

    case actionTypes.AGENT_PROFILE_DETAILS_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          agent_profile_loading: false,
          agent_profile_loaded: false,
        }
      };
    }

    case actionTypes.AGENT_DELETED: {
      let index = -1;
      if (action.payload.user && action.payload.user.length > 0) {
        index = state.agents.findIndex(agent => agent._id === action.payload.user[0]._id);
      }
      return {
        ...state,
        agents: index !== -1 ? [...state.agents.slice(0, index), action.payload.user[0], ...state.agents.slice(index + 1)] : [...state.agents],
      };
    }

    case actionTypes.GROUPS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          groups_loading: true,
          groups_loaded: false,
        }
      };
    }

    case actionTypes.GROUPS_LOADED: {
      return {
        ...state,
        groups: action.payload.agentGroupList ? action.payload.agentGroupList : [...state.groups],
        active_group: action.payload.agentGroupList && action.payload.agentGroupList.length > 0 ? action.payload.agentGroupList[0] : {},
        loaders: {
          ...state.loaders,
          groups_loading: false,
          groups_loaded: true,
        }
      };
    }

    case actionTypes.GROUPS_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          groups_loading: false,
          groups_loaded: false,
        }
      };
    }

    case actionTypes.GROUP_DELETED: {
      let index = -1;
      let active_group = { ...state.active_group };
      let groups = { ...state.groups };
      if (action.payload.deletedGroup && action.payload.deletedGroup._id) {
        index = state.groups.findIndex(response => response._id === action.payload.deletedGroup._id);
        if (index !== -1) {
          groups = [...state.groups.slice(0, index), ...state.groups.slice(index + 1)];
          if (active_group._id && active_group._id === action.payload.deletedGroup._id) {
            active_group = groups.length > 0 ? groups[0] : {};
          }
        }
      }
      return {
        ...state,
        groups,
        active_group,
      };
    }

    case actionTypes.CANNED_RESPONSES_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          canned_responses_loading: true,
          canned_responses_loaded: false,
        }
      };
    }

    case actionTypes.CANNED_RESPONSES_LOADED: {
      return {
        ...state,
        canned_responses: action.payload.cannedResponseList ? action.payload.cannedResponseList : [...state.canned_responses],
        loaders: {
          ...state.loaders,
          canned_responses_loading: false,
          canned_responses_loaded: true,
        }
      };
    }

    case actionTypes.CANNED_RESPONSES_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          canned_responses_loading: false,
          canned_responses_loaded: false,
        }
      };
    }

    case actionTypes.CANNED_RESPONSE_CREATED: {
      return {
        ...state,
        canned_responses: action.payload.createdCannedResponse ? [action.payload.createdCannedResponse, ...state.canned_responses] : [...state.canned_responses],
      };
    }

    case actionTypes.CANNED_RESPONSE_UPDATED: {
      let index = -1;
      if (action.payload.updatedCannedResponse && action.payload.updatedCannedResponse._id) {
        index = state.canned_responses.findIndex(response => response._id === action.payload.updatedCannedResponse._id);
      }
      return {
        ...state,
        canned_responses: index !== -1 ? [...state.canned_responses.slice(0, index), action.payload.updatedCannedResponse, ...state.canned_responses.slice(index + 1)] : [...state.canned_responses]
      };
    }

    case actionTypes.CANNED_RESPONSE_DELETED: {
      let index = -1;
      if (action.payload.deletedCannedResponse && action.payload.deletedCannedResponse._id) {
        index = state.canned_responses.findIndex(response => response._id === action.payload.deletedCannedResponse._id);
      }
      return {
        ...state,
        canned_responses: index !== -1 ? [...state.canned_responses.slice(0, index), ...state.canned_responses.slice(index + 1)] : [...state.canned_responses]
      };
    }

    case actionTypes.UPDATE_TRANSFER_CHAT_DATA: {
      let agent_list = { ...state.transfer_chat.agent_list };
      if (action.payload && action.payload.agentList) {
        let list = {};
        action.payload.agentList.forEach(agent => {
          list[agent.psid] = agent;
        });
        agent_list = list;
      }
      return {
        ...state,
        transfer_chat: {
          selected_group: action.payload && action.payload.selectedGroup ? action.payload.selectedGroup : state.transfer_chat.selected_group,
          agent_list,
        }
      }
    }

    case actionTypes.AGENT_AVAILABILITY_UPDATE: {
      let agent_list = { ...state.transfer_chat.agent_list };
      if (action.payload && action.payload.updatedAgent && action.payload.updatedAgent.psid) {
        agent_list[action.payload.updatedAgent.psid] = action.payload.updatedAgent;
      }
      return {
        ...state,
        transfer_chat: {
          ...state.transfer_chat,
          agent_list,
        }
      }
    }

    case actionTypes.TAGS_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          tags_loading: true,
          tags_loaded: false,
        }
      };
    }

    case actionTypes.TAGS_LOADED: {
      return {
        ...state,
        tags: action.payload.allTagsList ? action.payload.allTagsList : [...state.tags],
        loaders: {
          ...state.loaders,
          tags_loading: false,
          tags_loaded: true,
        }
      };
    }

    case actionTypes.TAGS_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          tags_loading: false,
          tags_loaded: false,
        }
      };
    }

    case actionTypes.TAG_CREATED: {
      return {
        ...state,
        tags: [action.payload, ...state.tags],
      };
    }

    case actionTypes.TAG_UPDATED: {
      let index = -1;
      index = state.tags.findIndex(tag => tag._id === action.payload._id);
      return {
        ...state,
        tags: index !== -1 ? [...state.tags.slice(0, index), action.payload, ...state.tags.slice(index + 1)] : [...state.tags],
      };
    }

    case actionTypes.TAG_DELETED: {
      let index = -1;
      index = state.tags.findIndex(tag => tag._id === action.payload._id);
      return {
        ...state,
        tags: index !== -1 ? [...state.tags.slice(0, index), ...state.tags.slice(index + 1)] : [...state.tags],
      };
    }

    default:
      return state;
  }
};

export default member_details;



// WEBPACK FOOTER //
// ./src/data/redux/member_details/reducers.js